module.exports = __webpack_public_path__ + "static/mobileapp-7a72bb3700e927b5950385eddc40dd03.svg";